export default {
  components: {
  },
  props: ['type'],
  data () {
    return {
      citytitle: ''
    };
  },
  created () {
  },
  computed: {
  },
  methods: {
  }
};
